import React from 'react'
import Manager from '../../public/components/Manager'
// import VacationDeductionInfoDiv from './VacationDeductionInfoDiv'
Ext.require('Ext.Toast')

const config = {
    tabs: {
        已验收: {
            buttons: [
            ],
            columns: [
                { _text: '物料代码', field: 'ReqPurchaseInfo.MaterialNumber', minWidth: 150, search: true, flex: 1 },
                { _text: '物料名称', field: 'ReqPurchaseInfo.MaterialName', minWidth: 150, flex: 1 },
                { _text: '规格型号', field: 'ReqPurchaseInfo.SpecificationModel', minWidth: 150, flex: 1 },
                { _text: '单位', field: 'ReqPurchaseInfo.Unit', minWidth: 80, flex: 1 },
                { _number: '数量', field: 'AccQuantity', minWidth: 80, flex: 1 },
                { _date: '建议采购时间', field: 'ReqPurchaseInfo.PoposalPurchaseDate', minWidth: 150, flex: 1 },
                { _text: '用途', field: 'ReqPurchaseInfo.Purpose', minWidth: 150, flex: 1 },
                { _text: '供应商', field: 'ReqPurchaseInfo.Supplier', minWidth: 250, search: true, flex: 1 },
                { _number: '单价', field: 'ReqPurchaseInfo.LCNoTaxUnit', minWidth: 150, flex: 1 },
                { _text: '税率(%)', field: 'ReqPurchaseInfo.TaxRate', minWidth: 150, flex: 1 },
                { _number: '含税单价', field: 'ReqPurchaseInfo.LCTaxUnit', minWidth: 150, flex: 1 },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1 },
                { _date: '到货日期', field: 'ReqPurchaseInfo.ArrivalDate', minWidth: 150, flex: 1 },
                { _text: '申请部门', field: 'CreateDep', minWidth: 250, flex: 1 },
                { _text: '请购类别', field: 'ReqPurchaseInfo.RequisitionStatus', minWidth: 150, flex: 1 },
                { _datetime: '验收时间', field: 'AccTime', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
            }
        },
        不予验收: {
            buttons: [
            ],
            columns: [
                { _text: '物料代码', field: 'ReqPurchaseInfo.MaterialNumber', minWidth: 150, search: true, flex: 1 },
                { _text: '物料名称', field: 'ReqPurchaseInfo.MaterialName', minWidth: 150, flex: 1 },
                { _text: '规格型号', field: 'ReqPurchaseInfo.SpecificationModel', minWidth: 150, flex: 1 },
                { _text: '单位', field: 'ReqPurchaseInfo.Unit', minWidth: 80, flex: 1 },
                { _number: '数量', field: 'AccQuantity', minWidth: 80, flex: 1 },
                { _date: '建议采购时间', field: 'ReqPurchaseInfo.PoposalPurchaseDate', minWidth: 150, flex: 1 },
                { _text: '用途', field: 'ReqPurchaseInfo.Purpose', minWidth: 150, flex: 1 },
                { _text: '供应商', field: 'ReqPurchaseInfo.Supplier', minWidth: 250, search: true, flex: 1 },
                { _number: '单价', field: 'ReqPurchaseInfo.LCNoTaxUnit', minWidth: 150, flex: 1 },
                { _text: '税率(%)', field: 'ReqPurchaseInfo.TaxRate', minWidth: 150, flex: 1 },
                { _number: '含税单价', field: 'ReqPurchaseInfo.LCTaxUnit', minWidth: 150, flex: 1 },
                { _text: '申请人', field: 'Creator', minWidth: 150, flex: 1 },
                { _date: '到货日期', field: 'ReqPurchaseInfo.ArrivalDate', minWidth: 150, flex: 1 },
                { _text: '申请部门', field: 'CreateDep', minWidth: 250, flex: 1 },
                { _text: '请购类别', field: 'ReqPurchaseInfo.RequisitionStatus', minWidth: 150, flex: 1 },
                { _text: '不予验收原因', field: 'NoAccReason', minWidth: 150, flex: 1 },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
            }
        }
    }
}

export default props => <Manager {...props} config={config} />